var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34401 9.48343C1.38759 11.5271 1.40938 12.549 2.16347 13.3059C2.91755 14.0629 3.96705 14.0892 6.06605 14.142C7.3597 14.1745 8.64063 14.1745 9.9343 14.142C12.0333 14.0892 13.0828 14.0629 13.8368 13.3059C14.591 12.549 14.6128 11.5271 14.6563 9.48343C14.6704 8.8263 14.6704 8.17303 14.6563 7.51596C14.6128 5.47225 14.591 4.4504 13.8368 3.69345C13.0828 2.9365 12.0333 2.91013 9.9343 2.85739C8.64063 2.82488 7.3597 2.82488 6.06605 2.85738C3.96705 2.91012 2.91755 2.93648 2.16347 3.69344C1.40938 4.4504 1.38759 5.47224 1.34401 7.51589C1.32999 8.17303 1.32999 8.8263 1.34401 9.48343Z",
    fill: "#8790A1",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 6.16699L6.62785 7.32659C7.7713 8.00266 8.22837 8.00266 9.37184 7.32659L11.3332 6.16699",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailGrey);
export default __webpack_public_path__ + "static/media/mail_grey.da254a7f48ca75de18a42ed57a44ee42.svg";
export { ForwardRef as ReactComponent };